/* ---- sticky add to cart ---- */
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.displayMode = this.dataset.displayMode || (this.dataset.afterScroll === "true" ? "after_scroll" : "always");
    this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0);
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.displayMode === "always") {
      this.floatingBtns.forEach(t => {
        t.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    } else {
      this.checkScroll();
      document.addEventListener("scroll", this.checkScroll.bind(this));
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkScroll() {
    let t = false;
    if (this.displayMode === "after_scroll") {
      if (!this.mainAtcBtn) {
        return;
      }
      let x = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY;
      let e = x + this.mainAtcBtn.offsetHeight;
      t = window.scrollY > e;
    } else if (this.displayMode === "after_pixels") {
      t = window.scrollY > this.displayThreshold;
    } else if (this.displayMode === "after_percent") {
      let i = document.documentElement.scrollHeight - window.innerHeight;
      t = i <= 0 || window.scrollY / i * 100 > this.displayThreshold;
    }
    if (t) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(t => {
      t.style.setProperty("--sticky-atc-offset", this.scrolledPast ? this.offsetHeight + "px" : "0px");
    });
  }
  handleScrollBtn() {
    let t = document.querySelector("sticky-header");
    let x = t ? t.clientHeight : 0;
    let e = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: e - x - 15,
      behavior: "smooth"
    });
  }
  footerSpacing() {
    let t = document.querySelector(".sticky-atc-footer-spacer");
    if (t) {
      return;
    }
    (t = document.createElement("div")).className = "sticky-atc-footer-spacer";
    t.style.height = this.clientHeight - 1 + "px";
    t.style.display = "block";
    let x = document.querySelector(".footer");
    if (x) {
      t.style.background = window.getComputedStyle(x).background;
    }
    document.body.appendChild(t);
  }
}
customElements.define("sticky-atc", StickyAtc);
